import { Button } from '@/components'

export const SystemNotFoundGeneracTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 text-gray-700 rounded font-body">
        <h4 className="font-semibold text-gray-800">For Generac Systems</h4>
        <p className="my-4">
            Your company successfully associated your PWRfleet account with Solar Insure at the company level,
            but we were unable to view details for this specific site. This most often occurs when a company
            forgets to share an individual site or neglects to add a site ID to the warranty enrollment,
            hindering Solar Insure's ability to locate it in PWRfleet. You must share access with Solar
            Insure at the fleet and site level for data to appear on the Solar Insure platform.
        </p>
        <h5 className="font-semibold text-gray-800">
            Step One: Add a Manufacturer System ID to the Warranty Details
        </h5>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Navigate</span> to
                the <span className="font-semibold">"Warranty Holder Details - Warranty Tab".</span>
            </li>
            <li>
                <span className="font-semibold">Click</span> on the <span className="font-semibold">"Edit
                        Warranty"</span> option to access and modify the warranty enrollment details.
            </li>
            <li>
                Make sure that the Manufacturer System Identifier is populated and correct. This should be
                populated with the site ID for the related installation found in
                your <a
                    href="https://pwrfleet.generac.com/login"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary-700 underline"
                >PWRfleet portal.</a>
                <div>
                    a. In PWRfleet, Navigate to the "All Sites" list to find the related system.
                </div>
                <div>
                    b. Click on the system to open its details page.
                </div>
                <div>
                    c. The Site ID can be found in the URL of the site. It is the unique identifier after
                    /sites/ in the URL.
                </div>
            </li>
            <li>
                Update the ID on Solar Insure Daybreak Platform and save the changes.
            </li>
        </ul>
        <h5 className="font-semibold my-4 text-gray-800">
            Step Two: Verify that the Individual Site is Shared with Solar Insure
        </h5>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                Log into the <a
                    href="https://pwrfleet.generac.com/login"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary-700 underline"
                >PWRfleet portal.</a> portal.
            </li>
            <li>
                Navigate to the "All Sites" list to find the related system. Click on the system
                to open its details page.
            </li>
            <li>Click on the “Access” tab in the left sidebar.</li>
            <li>Select “Share Site”</li>
            <li>Select Solar Insure and click “Share”.</li>
            <li>
                Return to the Daybreak platform. Click on the refresh monitoring button to initiate a new
                attempt to pull monitoring data.
            </li>
        </ul>
        <Button
            design="btn-secondary"
            className="block text-center mt-4 w-fit"
            target="_blank"
            href="/resources/Generac_Fleet_&_Site_Level_Integrations.pdf"
        >
            Click here for a Visual Guide
        </Button>
    </div>
